<template>
    <div class="modal-card">
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <header class="modal-card-head has-background-white">
                <h3 class="modal-card-title has-text-centered">
                    {{ titleModal }}
                </h3>
                <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
            </header>
            <section class="modal-card-body box-body">
                <div class="px-6">
                    <div class="columns is-mobile is-multiline is-vcentered">
                        <div class="column is-12-mobile">
                            <div class="is-size-6 has-text-weight-light">
                                <strong>
                                    {{ msgHelp }}
                                </strong>
                                <span v-for="(item, index) in listHelp" :key="index">
                                    <br />
                                    {{ index + 1 }}. {{ item }}
                                </span>
                                <br />
                                <br />

                                <div v-if="!hideDefaultPlanilla">
                                    <strong><a class="has-text-secondary" :href="`${hostname}/xlsx/${planillaName}.xlsx`
            " download>Descarga la planilla aquí</a>
                                    </strong>
                                    <span v-if="kind_file == 'remuneration' && bookIsValidated">
                                        o
                                        <strong><a class="has-text-secondary" :href="uploadedBookUrl" download>descarga tu
                                                última planilla</a>
                                        </strong> </span>, complétala con la información de tus
                                    <strong> {{ msgFileName }}, </strong>y
                                    arrástrala a este modal.
                                </div>
                                <div v-if="hideDefaultPlanilla">
                                    <strong> {{ msgUpload }}, </strong> y arrastra los documentos a este modal.
                                </div>
                            </div>
                            <div class="divisionLine"></div>
                            <UploadFile :fileName="fileName" :messageFormat="messageFormat || 'XLSX'"
                                :extensionAccept="extensionAccept || '.xlsx'" :isLoading="loading" @uploaded="uploaded"
                                @removed-file="removedFile" />
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
                <b-button class="button is-primary" aria-label="Subir archivo" :disabled="!fileBook || loading"
                    :loading="loading" role="button" @click="handleSubmit(uploadFile())">
                    Subir
                </b-button>
            </footer>
        </ValidationObserver>
    </div>
</template>

<script>
import UploadFile from "@/components/uploadFile/UploadFile";
import { consoleHandlerError, notificate } from "@/utils/message";
import { ValidationObserver } from "vee-validate";
import { mapActions, mapState } from "vuex";

export default {
    name: "BookRemunerations",
    components: {
        ValidationObserver,
        UploadFile,
    },
    data() {
        return {
            publicPath: window.location.hostname,
            localhost: ["localhost", "0.0.0.0"],
            uploadedBookUrl: null,
            fileBook: null,
            loading: false,
        };
    },
    methods: {
        ...mapActions("bookRemunerations", ["callCreateBookRemuneration"]),
        uploadFile() {
            this.loading = true;

            let formData = new FormData();
            formData.append("url_file", this.fileBook);
            formData.append("errors", "");
            formData.append("kind_file", this.kind_file);
            formData.append("file_type", this.kind_file);
            if (this.userIdSuplanted) {
                formData.append("user_id_suplanted", this.userIdSuplanted);
            }

            this.callCreateBookRemuneration(formData)
                .then(() => {
                    notificate(
                        "Libro de remuneraciones subido exitosamente",
                        "is-success is-light"
                    );
                    this.$emit("close");
                })
                .catch((error) => {
                    consoleHandlerError({
                        error,
                        customDefaultMessage:
                            "No se pudo procesar tu archivo, por favor inténtalo nuevamente",
                        empty: true,
                    });
                })
                .finally(() => {
                    this.$emit("clean-error");
                    this.loading = false;
                });
        },
        uploaded(file) {
            this.fileBook = file;
        },
        removedFile() {
            this.fileBook = null;
        },
        updateBookUrl(url) {
            this.uploadedBookUrl = url;
        },
    },
    computed: {
        ...mapState("bookRemunerations", ["webSocketRemunerations"]),
        hostname() {
            if (this.localhost.includes(window.location.hostname)) {
                return `http://${this.publicPath}`;
            } else {
                return `https://${this.publicPath}`;
            }
        },
        bookIsValidated() {
            const webSocketMsg = this.webSocketRemunerations.responseMessage;
            const isValidated =
                this.book.validation_status === "V" ||
                webSocketMsg.validation_status === "V";
            if (this.book.validation_status === "V") {
                this.updateBookUrl(this.book.url_file);
            } else {
                this.updateBookUrl(webSocketMsg.url_file);
            }
            return isValidated;
        },
    },
    props: [
        "book",
        "titleModal",
        "msgHelp",
        "listHelp",
        "msgFileName",
        "fileName",
        "kind_file",
        "planillaName",
        "hideDefaultPlanilla",
        "msgUpload",
        "messageFormat",
        "extensionAccept",
        "userIdSuplanted"
    ],
};
</script>
